(() => {
  const storageKey = 'ptc-recently-viewed';

  const initialize = async (section) => {
    if (!section || section.dataset.recentlyViewedReady === 'true') return;
    section.dataset.recentlyViewedReady = 'true';

    const useEmptyStateCopy = () => {
      const eyebrow = section.querySelector('[data-dynamic-carousel-eyebrow]');
      const heading = section.querySelector('[data-dynamic-carousel-heading]');
      const emptyEyebrow = section.dataset.emptyEyebrow || '';
      const emptyHeading = section.dataset.emptyHeading || '';
      if (eyebrow) {
        eyebrow.textContent = emptyEyebrow;
        eyebrow.hidden = !emptyEyebrow;
      }
      if (heading && emptyHeading) heading.textContent = emptyHeading;
    };

    let handles = [];
    try {
      handles = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      useEmptyStateCopy();
      return;
    }
    if (!Array.isArray(handles) || !handles.length) {
      useEmptyStateCopy();
      return;
    }

    const limit = Number(section.dataset.productsLimit || 12);
    const rootUrl = section.dataset.rootUrl || window.Shopify?.routes?.root || '/';
    const renderedCards = await Promise.all(handles.slice(0, limit).map(async (handle) => {
      try {
        const response = await fetch(`${rootUrl}products/${encodeURIComponent(handle)}?section_id=dynamic-product-card`, {
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) return null;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        return documentFragment.querySelector('.ptc-product-card');
      } catch (error) {
        return null;
      }
    }));
    const track = section.querySelector('[data-carousel-track]');
    if (!track) return;

    const availableCards = renderedCards.filter(Boolean);
    if (!availableCards.length) useEmptyStateCopy();
    const fallbackCards = [...track.querySelectorAll('.ptc-product-card')];
    const combinedCards = [];
    const seenHandles = new Set();

    [...availableCards, ...fallbackCards].forEach((card) => {
      const handle = card.dataset.productHandle;
      if (!handle || seenHandles.has(handle) || combinedCards.length >= limit) return;
      seenHandles.add(handle);
      combinedCards.push(card);
    });

    if (!combinedCards.length) return;
    track.replaceChildren(...combinedCards);

    track.scrollLeft = 0;
    track.dispatchEvent(new Event('scroll'));
    document.dispatchEvent(new CustomEvent('ptc:product-cards-updated', { detail: { section } }));
  };

  const initializeAll = (scope = document) => scope.querySelectorAll?.('[data-recently-viewed-carousel]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
